module.exports = "/wp-content/themes/lanthiaresort/modules/public/images/6d28e77dd32aa1e61433d5ba3d93ca86.png";